import { useEffect } from 'react';

const CRAZY_EGG_SCRIPT_SRC = '//script.crazyegg.com/pages/scripts/0077/4367.js';

// Extend the Window interface to include our custom flag
declare global {
  interface Window {
    __crazyEggLoaded?: boolean;
  }
}

function useCrazyEgg() {
  useEffect(() => {
    // Check global flag first, then DOM
    if (
      window.__crazyEggLoaded ||
      document.querySelector(`script[src="${CRAZY_EGG_SCRIPT_SRC}"]`)
    ) {
      return;
    }

    const loadCrazyEgg = () => {
      if (window.__crazyEggLoaded) return;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = CRAZY_EGG_SCRIPT_SRC;
      script.async = true;

      // Set the flag before appending to handle potential race conditions
      window.__crazyEggLoaded = true;
      document.head.appendChild(script);
    };

    // Load Crazy Egg after meaningful user interaction or after 10 seconds
    const events = ['click', 'keydown', 'touchstart'];
    const autoLoad = () => {
      events.forEach((event) => document.removeEventListener(event, loadCrazyEgg, true));
      loadCrazyEgg();
    };

    // Add event listeners for loading on meaningful interaction only
    events.forEach((event) => document.addEventListener(event, autoLoad, true));

    // Fallback: Load after 10 seconds (much later for analytics)
    const timer = setTimeout(autoLoad, 10000);

    return () => {
      clearTimeout(timer);
      events.forEach((event) => document.removeEventListener(event, autoLoad, true));
    };
  }, []);
}

export default useCrazyEgg;
